import { createStyles, rem } from '@mantine/core';
var useStyles = createStyles(function (theme, _ref) {
  var sticky = _ref.sticky,
      stickyOffset = _ref.stickyOffset;
  return {
    toolbar: {
      position: sticky ? "sticky" : "static",
      top: sticky ? rem(stickyOffset) : void 0,
      padding: "".concat(theme.spacing.xs, " ").concat(theme.spacing.md),
      backgroundColor: theme.colorScheme === "dark" ? theme.colors.dark[7] : theme.white,
      zIndex: 1,
      borderTopRightRadius: theme.fn.radius(),
      borderTopLeftRadius: theme.fn.radius(),
      borderBottom: "".concat(rem(1), " solid ").concat(theme.colorScheme === "dark" ? theme.colors.dark[4] : theme.colors.gray[4])
    }
  };
});
export default useStyles;